export class TrackingEvent {
    CategoryEvent?: string;
    LabelEvent?: string;
    ActionEvent?: string;
    PositionEvent?: string;
    LocationEvent?: string;
    EventDetails?: string;
    UrlClicked?: string;
    PageName?: string;
    SiteSection?: string;
    RefferingAction?: string;
    Value?: number | string | null;
    RegistrationType?: string | null;
    Product?: string;
    HccCategory?: string | null;
    HccArticle?: string | null;
    AffordabilityJourney?: string | null;
    ContentPosition?: number | string | null;
    RegistrationSourcePath?: string | null;
    Progress?: string;
    KycVerifcationProcess?: string;
    LimitDetails?: string;
    UserAccountId?: string | null;
    offerId?: string | null;
    type?: string | null;
    flowName?: string | null;
    AffordabilityGroups?: string | null;
    AffLimitType?: string | null;
    AffAgeGroups?: string | null;
}

export const EventNameConst = {
    HelpAndContact: 'Event.HCC',
    Tracking: 'Event.Tracking',
    Value: 'Event.Value',
    ContentView: 'contentView',
    AccountOptions: 'Event.AccountOptions',
};

export class ErrorDetail {
    [key: string]: string | number | undefined;
}

export const TrackingConstants: { [key: string]: string } = {
    COMPONENT_CATEGORY_EVENT: 'component.CategoryEvent',
    COMPONENT_LABEL_EVENT: 'component.LabelEvent',
    COMPONENT_ACTION_EVENT: 'component.ActionEvent',
    COMPONENT_POSITION_EVENT: 'component.PositionEvent',
    COMPONENT_LOCATION_EVENT: 'component.LocationEvent',
    COMPONENT_EVENT_DETAILS: 'component.EventDetails',
    COMPONENT_URL_CLICKED: 'component.URLClicked',
};

export const TrackingConstantsV2: { [key: string]: string } = {
    CATEGORY_EVENT: 'CategoryEvent',
    LABEL_EVENT: 'LabelEvent',
    ACTION_EVENT: 'ActionEvent',
    POSITION_EVENT: 'PositionEvent',
    LOCATION_EVENT: 'LocationEvent',
    EVENT_DETAILS: 'EventDetails',
    URL_CLICKED: 'UrlClicked',
};

export type TrackingConstantsType = (typeof TrackingConstants)[keyof typeof TrackingConstants];

export enum FieldEvent {
    Click = 'click',
    Blur = 'blur',
}
